 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"AdminChatManagement~AdminUsersLog~LiveSessions":"AdminChatManagement~AdminUsersLog~LiveSessions","AdminChatManagement":"AdminChatManagement","AdminDashboard":"AdminDashboard","AdminLogin":"AdminLogin","AdminMessageScreen":"AdminMessageScreen","AdminSession":"AdminSession","AdminUsersLog~LiveSessions~Login~Sessions":"AdminUsersLog~LiveSessions~Login~Sessions","AdminUsersLog~LiveSessions":"AdminUsersLog~LiveSessions","AdminUsersLog":"AdminUsersLog","AdminUser~LiveSessions~Login~Register":"AdminUser~LiveSessions~Login~Register","LiveSessions":"LiveSessions","Login":"Login","Sessions":"Sessions","AdminUser":"AdminUser","Register":"Register","Agenda":"Agenda","Home":"Home"}[chunkId]||chunkId) + "." + "9a4a7fc2" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AdminChatManagement":1,"AdminDashboard":1,"AdminLogin":1,"AdminMessageScreen":1,"AdminSession":1,"AdminUsersLog~LiveSessions":1,"AdminUsersLog":1,"LiveSessions":1,"Login":1,"Sessions":1,"AdminUser":1,"Register":1,"Agenda":1,"Home":1,"chunk-65fd6ce6":1,"chunk-743ce9ea":1,"chunk-744b2b32":1,"chunk-744b6cf3":1,"chunk-7466bf91":1,"chunk-7475a7b7":1,"chunk-748cb158":1,"chunk-7493160c":1,"chunk-749a8caa":1,"chunk-749e2f64":1,"chunk-74ac3230":1,"chunk-74aeff4e":1,"chunk-74c36769":1,"chunk-74c3762f":1,"chunk-74c4e212":1,"chunk-76f16481":1,"chunk-76fd13e2":1,"chunk-76fe6c08":1,"chunk-76ff43f1":1,"chunk-76ffb033":1,"chunk-77059982":1,"chunk-770744f8":1,"chunk-770caee3":1,"chunk-770d6351":1,"chunk-7718f88a":1,"chunk-771a661f":1,"chunk-772a8654":1,"chunk-7730745c":1,"chunk-7738d73b":1,"chunk-774c1e68":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AdminChatManagement~AdminUsersLog~LiveSessions":"AdminChatManagement~AdminUsersLog~LiveSessions","AdminChatManagement":"AdminChatManagement","AdminDashboard":"AdminDashboard","AdminLogin":"AdminLogin","AdminMessageScreen":"AdminMessageScreen","AdminSession":"AdminSession","AdminUsersLog~LiveSessions~Login~Sessions":"AdminUsersLog~LiveSessions~Login~Sessions","AdminUsersLog~LiveSessions":"AdminUsersLog~LiveSessions","AdminUsersLog":"AdminUsersLog","AdminUser~LiveSessions~Login~Register":"AdminUser~LiveSessions~Login~Register","LiveSessions":"LiveSessions","Login":"Login","Sessions":"Sessions","AdminUser":"AdminUser","Register":"Register","Agenda":"Agenda","Home":"Home"}[chunkId]||chunkId) + "." + {"AdminChatManagement~AdminUsersLog~LiveSessions":"31d6cfe0","AdminChatManagement":"9eb9ba0f","AdminDashboard":"1759f4d6","AdminLogin":"7155f5d3","AdminMessageScreen":"3870cf67","AdminSession":"1fab25fa","AdminUsersLog~LiveSessions~Login~Sessions":"31d6cfe0","AdminUsersLog~LiveSessions":"8ca05fad","AdminUsersLog":"1d49224a","AdminUser~LiveSessions~Login~Register":"31d6cfe0","LiveSessions":"1c31f86d","Login":"91c37608","Sessions":"83b0496d","AdminUser":"6aab3ee1","Register":"310f0359","Agenda":"f00fb1c7","Home":"140a49e4","chunk-65fd6ce6":"7334db28","chunk-743ce9ea":"1c518864","chunk-744b2b32":"5c14f73f","chunk-744b6cf3":"c4693a27","chunk-7466bf91":"16f6f2e8","chunk-7475a7b7":"80007b9f","chunk-748cb158":"a6a19ba3","chunk-7493160c":"70be7056","chunk-749a8caa":"fdbdbf5c","chunk-749e2f64":"fdbdbf5c","chunk-74ac3230":"3edc4233","chunk-74aeff4e":"b6a53eb4","chunk-74c36769":"8ed28e74","chunk-74c3762f":"fdbdbf5c","chunk-74c4e212":"74e5e87e","chunk-76f16481":"e63370a2","chunk-76fd13e2":"b5c68b03","chunk-76fe6c08":"4981b303","chunk-76ff43f1":"f2ef48c1","chunk-76ffb033":"c986c275","chunk-77059982":"7f0dda06","chunk-770744f8":"fdbdbf5c","chunk-770caee3":"6cc73ccb","chunk-770d6351":"eae87812","chunk-7718f88a":"cf9a3ff1","chunk-771a661f":"2f890e34","chunk-772a8654":"51b837b6","chunk-7730745c":"6cc73ccb","chunk-7738d73b":"b00e991a","chunk-774c1e68":"208fe317"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
